/**
 * Spinning Logo - Entry point
 */

import { SpinningLogoRenderer } from './renderer.js';

export { SpinningLogoRenderer };

export function initSpinningLogos() {
  const canvases = document.querySelectorAll('.spinning-logo');
  console.log('initSpinningLogos: Found', canvases.length, 'spinning logo canvases');

  canvases.forEach(canvas => {
    console.log('Setting up spinning logo for canvas:', canvas);
    const src = canvas.dataset.src;
    const outlineData = JSON.parse(canvas.dataset.outline || '{}');

    // Create a regular img element to show by default
    const img = document.createElement('img');
    img.src = src;
    img.alt = canvas.dataset.alt || '';
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.display = 'block';
    img.style.objectFit = 'contain';
    img.style.backgroundColor = 'transparent';

    // Hide canvas initially
    canvas.style.display = 'none';
    canvas.style.width = '100%';
    canvas.style.height = '100%';

    // Insert img before canvas
    canvas.parentNode.insertBefore(img, canvas);

    const renderer = new SpinningLogoRenderer(canvas);

    // Handle resize to update canvas dimensions
    const resizeCanvas = () => {
      const wrapper = canvas.parentNode;
      const rect = wrapper.getBoundingClientRect();
      const dpr = window.devicePixelRatio || 1;

      // Update canvas display size
      canvas.style.width = rect.width + 'px';
      canvas.style.height = rect.height + 'px';

      // Update canvas buffer size for high DPI
      canvas.width = Math.floor(rect.width * dpr);
      canvas.height = Math.floor(rect.height * dpr);

      // Update renderer dimensions
      if (renderer.resize) {
        renderer.resize(canvas.width, canvas.height);
      }
    };

    renderer.loadTexture(src, () => {
      resizeCanvas();
      renderer.createMesh(outlineData);
      renderer.animate();
    });

    // Listen for resize events
    const resizeObserver = new ResizeObserver(() => {
      resizeCanvas();
    });
    resizeObserver.observe(canvas.parentNode);

    // Handle hover events - switch to WebGL on hover
    const showWebGL = () => {
      img.style.display = 'none';
      canvas.style.display = 'block';
      renderer.setHover(true);
    };

    const showImage = () => {
      renderer.setHover(false);
      // Wait for animation to complete before switching back
      const checkAndSwitch = () => {
        if (!renderer.isHovered && !renderer.isAnimating) {
          img.style.display = 'block';
          canvas.style.display = 'none';
        } else if (!renderer.isHovered) {
          setTimeout(checkAndSwitch, 100);
        }
      };
      setTimeout(checkAndSwitch, 100);
    };

    img.addEventListener('mouseenter', showWebGL);
    canvas.addEventListener('mouseleave', showImage);

    // Listen for programmatic spin trigger (for homepage animation)
    const handleLogoSpin = () => {
      console.log('Logo received spin trigger, canvas:', canvas);
      console.log('Renderer:', renderer);
      img.style.display = 'none';
      canvas.style.display = 'block';
      if (renderer && renderer.playOneAnimation) {
        console.log('Calling playOneAnimation');
        renderer.playOneAnimation(() => {
          console.log('Animation callback - switching back to image');
          // After animation completes, switch back to image
          img.style.display = 'block';
          canvas.style.display = 'none';
        });
      } else {
        console.error('Renderer or playOneAnimation not available');
      }
    };

    window.addEventListener('trigger-logo-spin', handleLogoSpin);
    console.log('Added trigger-logo-spin event listener for canvas');

    // Store renderer for cleanup if needed
    canvas._renderer = renderer;
    canvas._logoImg = img;
  });

  console.log('initSpinningLogos: Setup complete');
}

// Auto-initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSpinningLogos);
} else {
  initSpinningLogos();
}
